import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_METABASE_CHART_LOAD_IFRAME_URLS } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';
import SrBox from 'client/components/SrBox';
import './SrMetabaseCharts.less';

const SrMetabaseCharts = ({ charts, dispatch }) => {
  const [loadedMetabaseCharts, setLoadedMetabaseCharts] = useState(null);

  useEffect(() => {
    dispatch(postWithState, {
      action: SR_API_ACTION_METABASE_CHART_LOAD_IFRAME_URLS,
      payload: {
        metabaseChartIds: charts.map(({ id }) => id),
      },
    }).then((metabaseChartIframes) => {
      setLoadedMetabaseCharts(metabaseChartIframes);
    });
  }, [charts, dispatch]);

  if (!loadedMetabaseCharts) {
    return <div className="loading-gif" />;
  }

  return (
    <div className="SrMetabaseCharts">
      {loadedMetabaseCharts.map(({ iframeUrl, width, height }, index) => (
        <SrBox key={iframeUrl} paddingBottom="10px">
          <iframe
            styleName="reportIframe"
            title={`Report #${index}`}
            width={width}
            height={height}
            src={iframeUrl}
          />
        </SrBox>
      ))}
    </div>
  );
};

SrMetabaseCharts.propTypes = {
  charts: PropTypes.array.isRequired,
};

SrMetabaseCharts.displayName = 'SrMetabaseCharts';

export default SrMetabaseCharts;
